import './SingleImage.css';
import React from 'react';
import { injectImageResolution } from '../../../utils';
import LazyPicture from '../../atoms/LazyPicture';
const SingleImage = _ref => {
  let {
    imgSrc,
    alt
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: commonStyles
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    className: `section-detail-content--single__picture`
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: `${injectImageResolution(imgSrc, 700, 700)}`
  }), /*#__PURE__*/React.createElement("img", {
    src: `${injectImageResolution(imgSrc, 325, 325)}`,
    alt: alt
  })));
};
const commonStyles = "c98wo61";
export default SingleImage;